<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="12" md="4" class="px-10">
                    <h1 class="mb-5">Automate Any Task in Your Workspace</h1>
                    <div>
                        <v-list class="features">
                            <v-list-item v-for="item in items" :key="item.id">
                                <v-list-item-icon>
                                    <v-icon color="green">mdi-check-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                    <v-list-item-text>{{ item.text }}</v-list-item-text>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>
                </v-col>
                <v-col cols="12" md="4" class="px-10 d-flex align-center justify-center">
                    <v-img
                    src="../assets/img/sitemap.png"
                    contain
                    max-width="400px"
                    alt="sitemap" 
                    
                     /> 
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'WorkflowsFeatures',
    data: () => ({
        items: [
        {
            text: 'Trigger messages, follow-ups, and campaigns at the right time, without manual effort.',
            title: 'Automate customer journeys',
            value: 1,
        },
        {
            text: 'Connect CRMs, marketing tools, and communication platforms so your data flows automatically.',
            title: 'Integrate systems seamlessly',
            value: 2,
        },
        {
            text: 'Handle common customer inquiries instantly, escalate high-interest cases to agents, and reduce repetitive support tasks.',
            title: 'Build chatbots that save time',
            value: 3,
        },
        {
            text: 'Ensure your tools work together so your team can act on complete, accurate information.',
            title: 'Act as the glue between platforms',
            value: 3,
        },
        ]
    })
}
</script>

<style lang="scss">

</style>